export default __webpack_public_path__ + "static/media/note.2035ac3d.png";